import tick_icon from '../images/white_tick_icon.png';
const ButtonIcon = {
    tick: tick_icon,
}
export default ButtonIcon;
